<template>
  <div :class="'login ' + currentBgClass">
    <div class="login-con">
      <div class="ivu-card">
        <div class="ivu-card-head">
          <p>
            <i class="ivu-icon ivu-icon-log-in"></i>
            <span>{{ "欢迎登录" + systemName }}</span>
          </p>
        </div>
        <div class="ivu-card-body">
          <div class="form-con">
            <el-form
              :model="loginForm"
              :rules="rules"
              ref="loginForm"
              label-width="100px"
            >
              <el-form-item
                v-if="isShowPerinfoList"
                label="考核期次"
                prop="ExamPeriodInfoId"
              >
                <el-select
                  v-model="loginForm.ExamPeriodInfoId"
                  class="form-input-full"
                  placeholder="请选择考核期次"
                  @change="setCurrentItem"
                >
                  <el-option
                    v-for="item in examPeriodInfoList"
                    :key="item.Id"
                    :label="item.Name"
                    :value="item.Id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="身份证号" prop="IDCard">
                <el-input
                  v-model="loginForm.IDCard"
                  class="form-input-full"
                  placeholder="请输入18位身份证号"
                  maxlength="18"
                  @keyup.enter.native="submitForm()"
                ></el-input>
              </el-form-item>
              <el-form-item>
                <el-button
                  :disabled="btnIsDisable"
                  :type="currentIsExam ? 'primary' : 'success'"
                  @click="submitForm()"
                  v-loading.fullscreen.lock="fullscreenLoading"
                >
                  {{ currentIsExam ? "登录" : "模拟" }}</el-button
                >
                <el-button @click="resetForm()">重置</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getExamPeriodInfoList,
  getQuestionList,
  getIDCardRelevanceExamPeriodInfoList,
} from "../api/index.js";
import { createQuestionRsaSession, buildExamDataFromResponse } from "../utils/questionCrypto.js";
import { createIdCardRsaSession, buildEncryptedIdCardPayload } from "../utils/idCardCrypto.js";
export default {
  name: "Index",
  data() {
    return {
      systemName: "山西传人科技企业培训综合管理平台",
      examPeriodInfoList: [],
      btnIsDisable: false,
      currentIsExam: true,
      loginForm: {
        IDCard: "",
        ExamPeriodInfoId: "",
        IsTest: false,
      },
      rules: {
        IDCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" },
          {
            min: 18,
            max: 18,
            message: "请输入正确的身份证号",
            trigger: "blur",
          },
        ],
        ExamPeriodInfoId: [
          { required: true, message: "请选择考核期", trigger: "change" },
        ],
      },
      changeBgTimer: null,
      currentBgindex: 0,
      currentBgClass: "login-bg0",
      pageRouteKey: "",
      isShowPerinfoList: false,
      idCardRsaSession: null,
      fullscreenLoading: false,
    };
  },
  methods: {
    submitForm() {
      let _this = this;
      this.$refs["loginForm"].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        try {
          _this.idCardRsaSession = await createIdCardRsaSession();
        } catch (error) {
          _this.$message.error(
            (error && error.message) || "加密组件初始化失败，请刷新页面后重试"
          );
          return false;
        }
        if (_this.isShowPerinfoList == true) {
          _this.getExamQuestion();
          return;
        }
        let queryParam = buildEncryptedIdCardPayload(
          _this.loginForm.IDCard,
          _this.idCardRsaSession,
          _this.pageRouteKey
        );
        _this.btnIsDisable = true;
        getIDCardRelevanceExamPeriodInfoList(queryParam)
              .then((res) => {
                _this.btnIsDisable = false;
                if (res.state == "success") {
                  _this.examPeriodInfoList = res.data;
                  if (_this.examPeriodInfoList.length == 0) {
                    _this.$message.warning("未查询到您的考核期次信息");
                    return false;
                  } else if (_this.examPeriodInfoList.length > 1) {
                    _this.isShowPerinfoList = true;
                    return false;
                  }
                  _this.currentIsExam = !res.data[0].TestAble;
                  _this.loginForm.ExamPeriodInfoId = res.data[0].Id;
                  _this.getExamQuestion();
                } else {
                  _this.$message.error(res.message);
                }
              })
              .catch((error) => {
                _this.btnIsDisable = false;
                _this.$message.error("网络连接失败，请稍后重试");
              });
      });
    },
    //查询获取考核题目信息
    getExamQuestion() {
      let _this = this;
      let isTest = !this.currentIsExam;
      if (!_this.idCardRsaSession) {
        _this.$message.error("加密会话已失效，请重新登录");
        return;
      }
      _this.loginForm.IsTest = isTest;
      _this.btnIsDisable = true;
      _this.fullscreenLoading = true;
      let rsaSession;
      try {
        rsaSession = createQuestionRsaSession();
      } catch (error) {
        _this.btnIsDisable = false;
        _this.fullscreenLoading = false;
        _this.$message.error("加密组件初始化失败，请刷新页面后重试");
        return;
      }
      const idCardPayload = buildEncryptedIdCardPayload(
        _this.loginForm.IDCard,
        _this.idCardRsaSession,
        _this.pageRouteKey
      );
      const requestData = {
        ExamPeriodInfoId: _this.loginForm.ExamPeriodInfoId,
        IsTest: isTest,
        EncryptedIDCard: idCardPayload.EncryptedIDCard,
        RsaKey: idCardPayload.RsaKey,
        ClientPublic1: rsaSession.clientPublic1,
        ClientPublic2: rsaSession.clientPublic2,
      };
      getQuestionList(requestData)
        .then((res) => {
          _this.btnIsDisable = false;
          _this.fullscreenLoading = false;
          if (res.state == "success") {
            let examData;
            try {
              examData = buildExamDataFromResponse(res.data, rsaSession);
            } catch (error) {
              _this.$message.error(
                (error && error.message) || "试题解密失败，请刷新页面后重试"
              );
              return;
            }
            _this.resetForm();
            sessionStorage.setItem("examData", JSON.stringify(examData));
            if (isTest) {
              _this.$router.push("/test");
            } else {
              _this.$router.push("/exam");
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.btnIsDisable = false;
          _this.fullscreenLoading = false;
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //重置表单
    resetForm() {
      this.$refs["loginForm"].resetFields();
    },
    //联动判断是否展示模拟按钮
    setCurrentItem(itemData) {
      let _this = this;
      this.examPeriodInfoList.forEach((item) => {
        if (itemData == item.Id) {
          _this.currentIsExam = !item.TestAble;
        }
      });
    },
    //绑定考核期次信息
    bindExamPeriodInfo() {
      var _this = this;
      let queryParam = {
        routeKey: this.pageRouteKey,
      };
      getExamPeriodInfoList(queryParam)
        .then((res) => {
          if (res.state == "success") {
            _this.examPeriodInfoList = JSON.parse(res.data);
            if (_this.examPeriodInfoList.length == 0) {
              _this.btnIsDisable = true;
              _this.$message.warning("暂无考核期次");
            }
          } else {
            _this.$message.error(res.message);
          }
        })
        .catch((error) => {
          _this.$message.error("网络连接失败，请稍后重试");
        });
    },
    //自动切换背景图片
    autoChangeBg() {
      this.currentBgindex++;
      if (this.currentBgindex > 9) {
        this.currentBgindex = this.currentBgindex - 10;
      }
      this.currentBgClass = "login-bg" + this.currentBgindex;
    },
  },
  activated() {
    sessionStorage.setItem("indexPage", "index");
    this.currentBgindex = 0;
    this.isShowPerinfoList = false;
    let routeKey = "";
    let currentDomain = window.location.hostname;
    //根据域名判断rk值
    if (currentDomain.indexOf("sypxzx") > -1) {
      routeKey = "syyp";
      //写入缓存中
      sessionStorage.setItem("routeKey", routeKey);
    } else {
      //查询url中的单位编号信息
      routeKey = this.$route.query.rk;
      if (routeKey) {
        //写入缓存中
        sessionStorage.setItem("routeKey", routeKey);
      } else {
        //查询缓存中
        routeKey = sessionStorage.getItem("routeKey");
      }
    }
    if (routeKey) {
      //判断路由参数赋值系统名称
      switch (routeKey) {
        case "lf":
          document.title = "临汾市在线考核管理系统";
          this.systemName = "临汾市在线考核管理系统";
          break;
        case "jzzy":
          document.title = "晋中职院在线考核管理系统";
          this.systemName = "晋中职院在线考核管理系统";
          break;
        case "hmgh":
          document.title = "干河煤矿在线考核管理系统";
          this.systemName = "干河煤矿在线考核管理系统";
          break;
        case "ywmy":
          document.title = "余吾煤业在线考核管理系统";
          this.systemName = "余吾煤业在线考核管理系统";
          break;
        case "syyp":
          document.title = "寿阳县应急管理事务服务中心在线考核管理系统";
          this.systemName = "寿阳县应急管理事务服务中心在线考核管理系统";
          break;
        default:
          break;
      }
      this.pageRouteKey = routeKey;
      sessionStorage.setItem("systemName", this.systemName);
      //this.bindExamPeriodInfo();
    } else {
      this.$message.error("页面地址参数有误，请联系管理员");
    }
    if (!this.changeBgTimer) {
      this.changeBgTimer = setInterval(this.autoChangeBg, 60000);
    }
  },
};
</script>
<style scoped>
.login {
  width: 100%;
  height: 100%;
  background-color: #0a1628;
  background-size: cover;
  background-position: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-image 1s ease-in-out;
}

.login::before {
  content: "";
  position: absolute;
  inset: 0;
  background: rgba(10, 22, 40, 0.45);
  z-index: 0;
}

.login-bg0 { background-image: url("../assets/bg/0.jpg"); }
.login-bg1 { background-image: url("../assets/bg/1.jpg"); }
.login-bg2 { background-image: url("../assets/bg/2.jpg"); }
.login-bg3 { background-image: url("../assets/bg/3.jpg"); }
.login-bg4 { background-image: url("../assets/bg/4.jpg"); }
.login-bg5 { background-image: url("../assets/bg/5.jpg"); }
.login-bg6 { background-image: url("../assets/bg/6.jpg"); }
.login-bg7 { background-image: url("../assets/bg/7.jpg"); }
.login-bg8 { background-image: url("../assets/bg/8.jpg"); }
.login-bg9 { background-image: url("../assets/bg/9.jpg"); }

.login-con {
  position: relative;
  z-index: 1;
  width: 420px;
  max-width: 92vw;
}

.ivu-card {
  background: rgba(255, 255, 255, 0.97);
  border-radius: 12px;
  font-size: 14px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.25);
  overflow: hidden;
  backdrop-filter: blur(8px);
  transition: all 0.3s ease;
}

.ivu-card:hover {
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.3);
  transform: translateY(-2px);
}

.ivu-card-head {
  border-bottom: 1px solid #e8eaec;
  padding: 20px 24px;
  background: linear-gradient(135deg, #1e4d8c, #2f6cb5);
}

.ivu-card-head p {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 16px;
  color: #fff;
  font-weight: 600;
  margin: 0;
  line-height: 1.4;
}

.ivu-card-head p span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ivu-card-body {
  padding: 28px 24px 24px;
}

.form-con {
  padding: 0 8px;
}

.form-input-full {
  width: 100%;
}

.ivu-icon {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/views/Index.vue